<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Аптеки</strong>
                    <CLink to="/pharmacies/archive" class="float-right">Архив</CLink>
                </CCardHeader>

                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <CompaniesTable :data.sync="list" :service="'pharmacies'" archivable @archived="fetch" />
                    </template>
                </CCardBody>

                <CCardFooter v-if="adminOnly">
                    <CButton
                        color="primary"
                        @click="$router.push('/pharmacies/create')"
                    >Создать</CButton>

                    <CButton
                        class="ml-4"
                        color="info"
                        @click="reorder"
                    >Сохранить расположение</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import CompaniesTable from '@/components/CompaniesTable'

    export default {
        name: 'Pharmacies',

        components: {
            CompaniesTable,
        },

        data: () => ({
            loading: true,
            list: [],
        }),

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        },

        async created() {
            await this.fetch();
            this.loading = false;
        },

        methods: {
            async fetch() {
                try {
                    const { data } = await this.axios.get('/pharmacies')
                    this.list = data
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            async reorder() {
                try {
                    const payload = {
                        reorder: this.list.map((item, idx) => ({ id: item.id, position: idx + 1, title: item.title }))
                    };
                    const { data } = await this.axios.post('/pharmacies/reorder', payload)
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка сохранения порядка аптек.');
                }
            }
        }
    }
</script>
